import React, { useContext } from "react";
import { StoreContext } from "../../context/StoreContext";
import { useMatchMedia } from "../../util/useMatchMedia";
import Banner from "./Banner";
import BannerContent from "./BannerContent";
import Location from "./Location";
import Logo from "./Logo";
import Offers from "./Offers";
import SearchBox from "./SearchBox";
import CartBox from "./CartBox";
import { AppBar, Toolbar, Box } from '@mui/material';
import Cart from "../cart/Cart";
import ProductPopup from "../popup/ProductPopup";

const Header = () => {
  const { data } = useContext(StoreContext);
  const storeDetails = data.store_master;
  const isMobile = useMatchMedia("(max-width: 576px)", true);
  return (
    <AppBar position="static" className="header-app-bar">
      <Toolbar disableGutters className="header-toolbar">
        <div className="header-logo-container">
          <Logo sx={{ flexShrink: 0 }} />
        </div>
        <div className="header-search-container">
          <SearchBox />
        </div>
        <Cart className="header-cart-container" />
      </Toolbar>
    </AppBar>
  );
};

export default Header;
